import React from 'react';

const PageLoader = ({ message = 'กำลังโหลดข้อมูล...' }) => {
  return (
    <div className="page-loader">
      <div className="page-loader__content">
        <img src="/VERP.png" alt="VERP" className="page-loader__logo" />
        <div className="page-loader__bar">
          <div className="page-loader__bar-fill"></div>
        </div>
        {message && (
          <p className="page-loader__message">{message}</p>
        )}
      </div>
    </div>
  );
};

export default PageLoader;
